import { getMobileAndDesktopFirstImage } from '../utils';
import {
  MultipleCardsCarouselCard,
  MultipleCardsCarouselProps,
} from './MultipleCardsCarousel';

export function parseMultipleCardsCarousel(
  section: Queries.ContentfulSection001,
): MultipleCardsCarouselProps {
  const { eyebrow, metadata, body } = section || {};
  const { title } = metadata || {};

  const subsections = section?.subsections as Queries.ContentfulSection001[];

  const cards: MultipleCardsCarouselCard[] = subsections
    ? subsections?.map((subsection: Queries.ContentfulSection001) => {
        const { metadata } = subsection || {};

        const { desktopImage, mobileImage } = getMobileAndDesktopFirstImage(
          subsection.images,
        );

        return {
          title: metadata?.title,
          description: metadata?.description?.description,
          cta: {
            label: metadata?.ctas?.[0]?.label || '',
            url: metadata?.ctas?.[0]?.url || '',
          },
          desktopImage,
          mobileImage,
          tags: metadata?.flags || [],
        };
      })
    : [];

  return {
    eyebrow,
    title,
    disclaimer: {
      raw: body?.raw || '',
    },
    cards: cards,
  };
}
